import React from 'react';

const TextEditorSection = props => (
  <input type="text" {...props} />
);

export default TextEditorSection;
